import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { nestedRoutePath, routes } from '../../../constants/routes'

import ListLeads from './list'
import ViewLead from './view'

const LeadsIndex = () => {
    return (
        <Routes>
            <Route path={nestedRoutePath(routes.leadsIndex, routes.leadsView)} element={<ViewLead />} />
            <Route index element={<ListLeads />} />
        </Routes>
    )
}

export default LeadsIndex